import { render, staticRenderFns } from "./GamesSection.vue?vue&type=template&id=179b4100"
import script from "./GamesSection.vue?vue&type=script&lang=js"
export * from "./GamesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports